import { Injectable, signal } from '@angular/core';

/**
 * The rail's expanded/collapsed state, shared with the app frame (NBO-2331).
 *
 * The frame publishes the live rail width as the global `--app-rail-width`
 * custom property, because the `.full-screen-edit` overlay used by ~10 detail
 * screens is `position: fixed` against the VIEWPORT and has to inset itself by
 * the rail. It used to read a hardcoded 56px (and a
 * `.mat-drawer-side ~ .mat-sidenav-content` sibling selector that no longer
 * matches anything); a token keeps the two in sync with no DOM coupling.
 */
@Injectable({ providedIn: 'root' })
export class RailStateService {
  private readonly COLLAPSED_KEY = 'railCollapsed';

  readonly collapsed = signal(this.read());

  /** Rail widths from the canonical /mockups/shell/ia. */
  static readonly WIDTH_EXPANDED = 224;
  static readonly WIDTH_COLLAPSED = 56;

  toggle(): void {
    const next = !this.collapsed();
    this.collapsed.set(next);
    this.write(String(next));
  }

  private read(): boolean {
    try {
      return localStorage.getItem(this.COLLAPSED_KEY) === 'true';
    } catch {
      return false;
    }
  }

  private write(value: string): void {
    try {
      localStorage.setItem(this.COLLAPSED_KEY, value);
    } catch {
      // Collapse preference simply won't persist.
    }
  }
}
